





































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch, Prop, Mixins } from 'vue-property-decorator';
import { vxm } from './../store.vuex';
import { UserProfile } from '../models/userdata/profile';
import Datepicker from 'vuejs-datepicker';
import {en, de, es, fr} from 'vuejs-datepicker/dist/locale';
import { JobHistoryInfo } from '../models/jobs/jobhistoryinfo';
import JobHistoryPager from './JobHistoryPager.vue';
import { UserJobHistory } from '../models/jobs/userjobhistory';
import { UserCompanyInfo } from '../models/jobs/usercompanyinfo';
import { UserJobHistoryListRequest } from '../models/jobs/userjobhistorylistrequest';
import { ModelListSelect } from 'vue-search-select';
import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';
import { UserCompany } from '../models/jobs/usercompany';
import Avatar from 'vue-avatar';
import CandidatePortalLogo from './CandidatePortalLogo.vue';
import VueGoogleAutocomplete from 'vue-google-autocomplete';
import GuidedSignupUtilities from '@/components/GuidedSignup/utilities';

Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 5000,
});

@Component({
  name: 'JobHistoryDetails',
  components: {
    Datepicker,
    ModelListSelect,
    JobHistoryPager,
    Avatar,
    CandidatePortalLogo,
    VueGoogleAutocomplete,
  },
})
export default class JobHistoryDetails extends Mixins(GuidedSignupUtilities) {
  public $wlToastr: any;
  public $moment: any;
  private errorString: string = '';
  private isEditing: boolean = false;
  private jHistory: UserJobHistory = new UserJobHistory();
  private userCompanyListing: UserCompany[] = [];
  private userCompany: UserCompany = new UserCompany();
  private enableSave: boolean = false;
  private showAddNewjob: boolean = true;
  private addMode: boolean = false;
  private showAddJobHistory: boolean = false;
  private isTypeable: boolean = false;

  @Prop({ default: () => new Vue(), type: Vue }) bus;
  @Prop () isRequiredStep;
  @Prop () minimumEntries;

  @Watch('jobHistory')
  onJobHistoryChange(newVal, oldVal) {
    const disable = this.minimumEntries >= 0 ? (this.isRequiredStep
    ? newVal.length < this.minimumEntries : this.isRequiredStep) : newVal.length === 0;
    this.$emit('disable-next-button', disable);
  }

  get getLanguage() {
    const lang = vxm.users.getUserLang || 'en';
    return {en, de, es, fr}[lang];
  }
  
  get isLoggedIn() {
    return vxm.users.isLoggedIn;
  }

  get jobHistory(): JobHistoryInfo[] {
    if (!vxm.jobs.UserJobHistoryListResponse.jobHistoryList) {
      return [];
    }
    const list = vxm.jobs.UserJobHistoryListResponse.jobHistoryList;
    if (!Array.isArray(list)) {
      return [];
    }
    return list.map((jobH) => {
      const startDTTM = this.$moment(new Date(jobH['startDTTM'])).format(
        'YYYY-MM-DD',
      );
      const endDTTM = this.$moment(new Date(jobH['endDTTM'])).format(
        'YYYY-MM-DD',
      );
      return { ...jobH, startDTTM, endDTTM };
    });
  }

  mounted() {
    this.bus.$on('on-next-step', this.onNextStep);
    this.showAddJobHistory = !!vxm.configs.CanAddNewWorkExperience
    this.getJobHistory();
  }

  format(value, event) {
    console.log('Its called');
    return this.$moment(value).format(this.getCompanyDateFormat.toUpperCase());
  }

  beforeDestroy() {
    this.bus.$off('on-next-step');
  }

  onNextStep() {
    this.$emit('go-to-next');
  }

  get getCompanyDateFormat() {
    return vxm.jobs.getCompanyDateFormat;
  }

  getCompanyImage(companyCode) {
    const COMPANY_LOGO_URL = vxm.configs.getGlobalConfigValue(
      'CONTEXT_URL_COMPANY_LOGO_URL_ALIAS',
    );
    const LOGO_FILE_SEPERATOR = '/';
    const LOGO_FILE = vxm.utility.companyLogoFile;
    const CompanyLogoUrl =
      COMPANY_LOGO_URL +
      LOGO_FILE_SEPERATOR +
      companyCode +
      LOGO_FILE_SEPERATOR +
      LOGO_FILE;
    return CompanyLogoUrl;
  }

  public transferLoad(history: JobHistoryInfo) {
    this.jHistory.jobHistoryId = history.userCompanyJobHistoryId;
    this.jHistory.jobRole = history.jobRole;
    const startDate = new Date(history.startDTTM);
    this.jHistory.startDTTM = startDate.getTime();
    this.jHistory.startDTTMText = this.$moment(startDate).format(
      this.getCompanyDateFormat.toUpperCase(),
    );
    if (!history.currentJob) {
      const endDate = new Date(history.endDTTM);
      this.jHistory.endDTTM = endDate.getTime();
      this.jHistory.endDTTMText = this.$moment(endDate).format(
        this.getCompanyDateFormat.toUpperCase(),
      );
    }
    this.jHistory.currentJob = history.currentJob;
    this.jHistory.companyInfo = history.companyInfo;

    const uc = new UserCompany();
    uc.name = history.companyInfo.companyName;
    uc.code = history.companyInfo.companyCode;
    this.userCompanyListing = []; //added by santhosh as part of new theme
    this.userCompanyListing.push(uc);
    this.userCompany.name = history.companyInfo.companyName;
    this.userCompany.code = history.companyInfo.companyCode;

    this.jHistory.fullTimeJob = history.fullTimeJob;
    console.log('full time job:' + history.fullTimeJob);
    this.jHistory.function = 'U';
    console.log('load transferred');
    console.log('addnew job:' + this.showAddNewjob);
    this.addMode = false;
    this.showAddNewjob = false;
    // this.toggleEdit();
    // this.checkForSaveButton()
  }

  public transformDate(dttm: number): string {
    const locale = vxm.users.getUserLang || 'en';
    return this.$moment(dttm).locale(locale).format(this.getCompanyDateFormat.toUpperCase());
  }

  public toggleEdit() {
    this.isEditing = !this.isEditing;
  }

  public toggleShowAddNewjob() {
    this.showAddNewjob = !this.showAddNewjob;
  }

  public newJobHistory() {
    console.log('adding new job history');
    this.showAddNewjob = false;
    this.jHistory = new UserJobHistory();
    this.jHistory.function = 'A';
    this.isEditing = !this.isEditing;
    this.userCompanyListing = [];
    this.userCompany = new UserCompany();
    this.addMode = true;
    this.checkForSaveButton();
  }

  public cancelEdit() {
    this.jHistory = new UserJobHistory();
    this.jHistory.function = 'A';
    this.toggleEdit();
    this.checkForSaveButton();
  }

  public checkForSaveButton() {
    if (
      this.jHistory.jobRole &&
      this.jHistory.startDTTMText &&
      this.userCompany.name
    ) {
      this.enableSave = true;
    } else {
      this.enableSave = false;
    }
  }
  public updateJobHistory1() {
    //  console.log('save/update:'+'this.jHistory.startDTTM:'+this.jHistory.startDTTM+' this.jHistory.startDTTMText'+this.jHistory.startDTTMText+'new Date(history.startDTTM).toISOString().split(T)[0];'+new Date(this.jHistory.startDTTM).toISOString().split('T')[0]);
    console.log(this.jHistory);

    let userJobHistory = new UserJobHistory();
    userJobHistory.jobHistoryId = this.jHistory.jobHistoryId;
    userJobHistory.fullTimeJob = this.jHistory.fullTimeJob;
    userJobHistory.currentJob = this.jHistory.currentJob;
    if (!this.jHistory.function) {
      userJobHistory.function = 'A';
    } else {
      userJobHistory.function = this.jHistory.function;
    }

    if (
      !this.jHistory.startDTTMText ||
      (!this.jHistory.currentJob && !this.jHistory.endDTTMText) ||
      !this.jHistory.jobRole ||
      !this.jHistory.companyInfo
    ) {
      this.$wlToastr(
        'error',
        this.$t('NewJobHistoryDetails_WorkExperienceUpdateError'),
        this.$t('NewJobHistoryDetails_WorkExperience'),
      );
      return;
    }
    userJobHistory.jobRole = this.jHistory.jobRole;
    this.jHistory.startDTTM = new Date(this.jHistory.startDTTMText).getTime();
    userJobHistory.startDTTM = this.jHistory.startDTTM;
    userJobHistory.startDTTMText = this.jHistory.startDTTMText;
    if (!this.jHistory.currentJob) {
      this.jHistory.endDTTM = new Date(this.jHistory.endDTTMText).getTime();
      if (this.jHistory.startDTTM >= this.jHistory.endDTTM) {
        this.$wlToastr(
          'error',
          this.$t('NewJobHistoryDetails_WorkExperienceEndDateGreaterThanStartDateError'),
          this.$t('NewJobHistoryDetails_WorkExperience'),
        );
        return;
      }
      if (this.jHistory.endDTTM > new Date().getTime()) {
        this.$wlToastr(
          'error',
          this.$t('NewJobHistoryDetails_WorkExperienceFutereEndDateError'),
          this.$t('NewJobHistoryDetails_WorkExperience'),
        );
        return;
      }

      if (this.jHistory.startDTTM > new Date().getTime()) {
        this.$wlToastr(
          'error',
          this.$t('NewJobHistoryDetails_WorkExperienceFutereStartDateError'),
          this.$t('NewJobHistoryDetails_WorkExperience'),
        );
        return;
      }
      userJobHistory.endDTTM = this.jHistory.endDTTM;
      userJobHistory.endDTTMText = this.jHistory.endDTTMText;
    } else {
      if (this.jHistory.startDTTM > new Date().getTime()) {
        this.$wlToastr(
          'error',
          this.$t('NewJobHistoryDetails_WorkExperienceFutereStartDateError'),
          this.$t('NewJobHistoryDetails_WorkExperience'),
        );
        return;
      }
    }

    if (!this.userCompany.code || !this.userCompany.name) {
      this.$wlToastr(
        'error',
        'Company and location must be specified!',
        this.$t('NewJobHistoryDetails_WorkExperience'),
      );
      return;
    }

    if (!this.jHistory.companyInfo.companyCode) {
      let userCompanyInfo = new UserCompanyInfo();
      userCompanyInfo.companyCode = this.userCompany.code;
      userCompanyInfo.companyName = this.userCompany.name;
      userCompanyInfo.facilityAddress = this.jHistory.companyInfo.facilityAddress;
      userCompanyInfo.companyLogo = this.jHistory.companyInfo.companyLogo;
      userCompanyInfo.logoLastModified = this.jHistory.companyInfo.logoLastModified;
      userCompanyInfo.companyId = this.jHistory.companyInfo.companyId;
      userJobHistory.companyInfo = userCompanyInfo;
    } else {
      console.log('setting company code else:' + this.jHistory.companyInfo);  
      userJobHistory.companyInfo = this.jHistory.companyInfo;
      userJobHistory.companyInfo.companyName = this.userCompany.name ;
    }

    var result = new Date(userJobHistory.startDTTM);
    userJobHistory.startDTTM = result.getTime();
    var result1 = new Date(userJobHistory.endDTTM);
    userJobHistory.endDTTM = result1.getTime();

    vxm.jobs.updateJobHistory(userJobHistory).then((resp) => {
      if (
        vxm.jobs.UserJobHistoryUpdateResponse.meta &&
        vxm.jobs.UserJobHistoryUpdateResponse.meta['success']
      ) {
        this.$wlToastr(
          'success',
          this.$t('NewJobHistoryDetails_WorkExperienceUpdateSuccessful'),
          this.$t('NewJobHistoryDetails_WorkExperience'),
        );
        vxm.users.getProfileStrength();
        this.addMode = false;
        this.toggleShowAddNewjob();
        this.getJobHistory();
      } else {
        this.$wlToastr(
          'error',
          vxm.jobs.UserJobHistoryUpdateResponse.errorMessage,
          this.$t('NewJobHistoryDetails_WorkExperience'),
        );
      }
    });
  }

  public printSearchText(searchText: string) {
    this.setOutsideCompany(searchText);
    const vm = this;
    if (searchText.trim().length >= 3) {
      const respPromise: any = vxm.jobs.getCompanyListing(searchText);
      Promise.all([respPromise]).then((values) => {
        if (
          vxm.jobs.UserCompanyListing !== null &&
          vxm.jobs.UserCompanyListing.length > 0
        ) {
          console.log('database list:' + vxm.jobs.UserCompanyListing);
          this.userCompanyListing = vxm.jobs.UserCompanyListing;
        }
      });
    }
  }

  public setOutsideCompany(searchText: string) {
    if (!searchText) return;
    console.log(searchText);
    let uCompany = new UserCompany();
    uCompany.name = searchText;
    uCompany.code = vxm.users.getCompanyCode;
    this.userCompany = uCompany;
    if (this.userCompanyListing.length > 0) {
      this.userCompanyListing[0].name = searchText;
      this.userCompanyListing[0].code = vxm.users.getCompanyCode;
      this.userCompany.name = searchText;
      this.userCompany.code = vxm.users.getCompanyCode;
    } else {
      this.userCompanyListing.push(uCompany);
    }
  }

  public removeOptions() {
    this.userCompanyListing = [];
  }

  public deleteJobHistory() {
    console.log(this.jHistory);
    if (
      !this.jHistory.startDTTMText ||
      !this.jHistory.jobRole ||
      !this.jHistory.companyInfo
    ) {
      this.$wlToastr(
        'error', 
        this.$t('NewJobHistoryDetails_DeleteExperienceError'),
        this.$t('NewJobHistoryDetails_WorkExperience'),
      );
    } else {
      let userJobHistory = new UserJobHistory();
      //userJobHistory = this.jHistory;
      userJobHistory.function = 'D';
      userJobHistory.jobHistoryId = this.jHistory.jobHistoryId;
      userJobHistory.startDTTM = this.jHistory.startDTTM;
      userJobHistory.startDTTMText = this.jHistory.startDTTMText;
      userJobHistory.currentJob = this.jHistory.currentJob;
      userJobHistory.jobRole = this.jHistory.jobRole;
      userJobHistory.companyInfo = this.jHistory.companyInfo;
      userJobHistory.fullTimeJob = this.jHistory.fullTimeJob;
      if (!userJobHistory.currentJob) {
        userJobHistory.endDTTM = this.jHistory.endDTTM;
        userJobHistory.endDTTMText = this.jHistory.endDTTMText;
      }
      //userJobHistory.endDTTM = 32503593600000;
      // this.jHistory.function = 'D';

      vxm.jobs.deleteJobHistory(userJobHistory).then((resp) => {
        if (vxm.jobs.UserJobHistoryUpdateResponse.meta['success']) {
          this.$wlToastr(
            'success',
            this.$t('NewJobHistoryDetails_WorkExperienceDeleteSuccessful'),
            this.$t('NewJobHistoryDetails_WorkExperience'),
          );
          //this.toggleEdit();
          vxm.users.getProfileStrength();
          this.toggleShowAddNewjob();
          this.getJobHistory();
        } else {
          this.$wlToastr(
            'error',
            vxm.jobs.UserJobHistoryUpdateResponse.errorMessage,
            this.$t('NewJobHistoryDetails_WorkExperience'),
          );
        }
      });
    }
  }

  public getJobHistory() {
    const token = vxm.users.getToken;
    const jhr = new UserJobHistoryListRequest();
    jhr.resultSize = 10;
    jhr.resultPage = 1;
    vxm.jobs.getJobHistory(jhr);
  }

  public cancelAddNewJob() {
    this.showAddNewjob = true;
    if (this.addMode) this.addMode = false;
  }

  getFristCapitalletter(value: string): string {
    if (!value) return '';
    value = value.toString();
    return value
      .trim()
      .charAt(0)
      .toUpperCase();
  }

  public isCurrentCompany(value: string): boolean {
    if (value == 'KFORCEconnect') {
      console.log('returning true');
      return true;
    } else {
      console.log('returning false');
      return false;
    }
  }

  getAddressDataEdit(addressData, placeResultData, id) {
    if (addressData.locality && addressData.administrative_area_level_1) {
      this.jHistory.companyInfo.facilityAddress =
        addressData.locality + ', ' + addressData.administrative_area_level_1;
      return;
    }
    this.jHistory.companyInfo.facilityAddress =
      addressData.locality || addressData.administrative_area_level_1 || '';
  }

  onNoResultsEdit() {
    this.$wlToastr('error', this.$t('please-enter-valid-location-error-text'));
  }
}
